module.exports = __webpack_public_path__ + "af3f6dbe172a9c1aba77366a2ff630d1.woff2";